import React from 'react';
import { TEMPLATE_DIR } from '../../config';
import { useLetterStore } from '../../store/letterStore';

interface TemplateControllerProps {
  onTemplateChange: (template: string) => void;
}

const templates = [
  'letter-template01.jpg',
  'letter-template02.jpg',
  'letter-template03.jpg',
  'letter-template04.jpg',
  'letter-template05.jpg',
  'letter-template06.jpg',
  'letter-template07.jpg',
  'letter-template08.jpg',
  'letter-template09.jpg',
  'letter-template10.jpg',
  'letter-template11.jpg',
  'letter-template12.jpg',
  'letter-template13.jpg',
  'letter-template14.jpg',
  'letter-template15.jpg',
  'letter-template16.jpg',
];

const TemplateController: React.FC<TemplateControllerProps> = ({
  onTemplateChange,
}) => {
  const { letterData, setLetterData } = useLetterStore();

  const handleTemplateChange = (templateName: string) => {
    onTemplateChange(templateName);
    if (letterData) {
      setLetterData({
        template_name: templateName,
      });
    }
  };

  const currentTemplateName =
    letterData?.template_name || 'letter-template01.jpg';

  console.log('currentTemplateName', currentTemplateName);

  return (
    <div className='p-template-controller'>
      <ul className='p-template-controller__list'>
        {templates.map((template, index) => (
          <li key={index} className='p-template-controller__item'>
            <input
              type='radio'
              name='template'
              id={`template-${index}`}
              value={template}
              defaultChecked={currentTemplateName === template}
              onChange={() => handleTemplateChange(template)}
            />
            <label htmlFor={`template-${index}`}>
              <img
                src={`${TEMPLATE_DIR}/${template}`}
                alt={`template-${index}`}
              />
            </label>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default TemplateController;
